import React from "react";

export const ImageBackgroundComponent = ({ gradientTop, gradientBottom }) => {
  return (
    <svg
      width="432"
      height="432"
      viewBox="0 0 432 432"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M216 432C335.294 432 432 335.294 432 216C432 96.7065 335.294 0 216 0C96.7065 0 0 96.7065 0 216C0 335.294 96.7065 432 216 432Z"
        fill="url(#paint0_linear)"
        fill-opacity="0.9"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="432"
          y1="9.04225e-06"
          x2="249.525"
          y2="519.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.46875" stop-color={gradientTop} />
          <stop offset="1" stop-color={gradientBottom} />
        </linearGradient>
      </defs>
    </svg>
  );
};
